export default __webpack_public_path__ + "static/media/restaurant-logo.20a27201.svg";